import React, { createContext, FC, useCallback, useContext, useEffect, useState } from 'react';
import { useDeepMemo } from '@beeline.com/bp-design-system';
import { DataTableColumnConfigurationModel } from '@utmost.co/enterprise-models';
import { useLoggedInUser } from '../useLoggedInUser';
import { ColumnConfigurationContextProps } from './ColumnConfiguration.types';

export const ColumnConfigurationContext = createContext<ColumnConfigurationContextProps>({
  allColumnConfigurations: undefined,
  updateLocallyModel: () => {}
});

export const ColumnConfigurationsProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const authUser = useLoggedInUser();
  const [allConfigs, setAllConfigs] = useState<DeepPartial<DataTableColumnConfigurationModel>[] | undefined>();
  const allColumnConfigurations = authUser?.preferences?.dataTableColumnConfigurations;
  // biome-ignore lint/correctness/useExhaustiveDependencies: exception
  useEffect(() => {
    // Update and set local state.
    // 1. We want to rid of redux
    // 2. User store (redux) is not updated during the life cycle of app. So user will not see correct data
    setAllConfigs(allColumnConfigurations as unknown as DeepPartial<DataTableColumnConfigurationModel>[]);
  }, []);

  const updateLocallyModel = useCallback((updatedConfig: DeepPartial<DataTableColumnConfigurationModel>[]) => {
    setAllConfigs(updatedConfig);
  }, []);

  const contextValue = useDeepMemo(
    () => ({ allColumnConfigurations: allConfigs, updateLocallyModel }),
    [allConfigs, updateLocallyModel]
  );

  return <ColumnConfigurationContext.Provider value={contextValue}>{children}</ColumnConfigurationContext.Provider>;
};

export function useColumnConfigurationContext() {
  return useContext<ColumnConfigurationContextProps>(ColumnConfigurationContext);
}
